import { useQuery } from "react-query";
import { getAllApplicationRolesData } from "../api/applicationRoles";

// Get sftp connection react query hook
export const useGetAllApplicationRolesData = (options = {}) => {
  return useQuery(
    "allApplicationRolesData",
    () => getAllApplicationRolesData(),
    {
      ...options,
    },
  );
};

export default {
  useGetAllApplicationRolesData,
};
